import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Col, Row } from '_zari/core'

import * as PartidasService from 'services/partida.service'

import * as FormGroups from './formGroups'

const CrearEditarSection = ({ defaultValue, reloadTable, cancelOperation, idSocio }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      _id: defaultValue._id || '',
      _idSocio: idSocio,
      titulo: defaultValue.titulo || ''
    }
  }, [defaultValue, idSocio])

  const onSubmit = React.useCallback(
    data => {
      if (data._id) {
        PartidasService.actualizarxId(data._id, data)
          .then(() => {
            reloadTable()
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
      } else {
        PartidasService.nuevo(data)
          .then(() => {
            reloadTable()
          })
          .catch(({ data: { error } }) => __zariContext.snack('error', error))
      }
    },
    [__zariContext, reloadTable]
  )

  return (
    <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
      {({ errors, touched, isSubmitting, handleSubmit, values }) => (
        <Form>
          <FormGroups.TituloFormGroup
            fIsSubmitting={isSubmitting}
            iError={errors.titulo}
            iTouched={touched.titulo}
          />
          <Row className='mt-2'>
            <Col md={12} className='text-right'>
              <Button color='secondary' onClick={cancelOperation}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>{values._id ? 'Actualizar' : 'Crear'}</Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default React.memo(CrearEditarSection)
